import moment from 'moment';
import { parsePeriodicity } from '../../utils';

/**
 * Ports DynamicListTableNew.js's currency/date/boolean export-formatting
 * logic, reusing the existing utils.js columnInfo arrays as-is. `dataName`
 * must be passed exactly as it was to <DynamicListTableNew dataName=.../>
 * at each call site — the currency switch below keys off it verbatim
 * (including its pre-existing 'debtsDues' vs 'creditDues' inconsistency)
 * so formatting doesn't silently change.
 */

function showCurrency(currency, value) {
	if (currency === 'UYU') return '$U ' + value;
	if (currency === 'USD') return 'U$S ' + value;
	return value;
}

function getNestedValue(item, key) {
	const keys = key.split('.');
	let value = item;
	for (const part of keys) {
		if (value && value[part] !== undefined && value[part] !== 0 && value[part] !== null && value[part] !== '') {
			value = value[part];
		} else {
			return undefined;
		}
	}
	return value;
}

function formatCurrency(item, key, nestedValue, dataName) {
	switch (dataName) {
	case 'relWarranties':
		return showCurrency(item.warranty?.debt?.currency || item.warranty?.asset?.currency, nestedValue);
	case 'bills':
		return showCurrency(item.asset?.currency, nestedValue);
	case 'debtDues':
		return showCurrency(item.debt?.currency, nestedValue);
	case 'creditDues':
		return showCurrency(item.credit?.currency, nestedValue);
	default:
		return showCurrency(item.currency, nestedValue);
	}
}

function isVisibleColumn(colDef) {
	return !colDef.toExport;
}

function formatExportValue(item, key, colDef, dataName) {
	const nestedValue = getNestedValue(item, key);
	if (nestedValue === undefined) return 'N/A';
	if (key === 'periodicity') return parsePeriodicity(nestedValue.toString());
	if (colDef.type === 'boolean') return nestedValue ? 'Si' : 'No';
	if (colDef.type === 'date') {
		const date = moment.utc(nestedValue);
		return date.isValid() ? date.format('DD-MM-YYYY') : 'N/A';
	}
	if (colDef.type === 'currency') return formatCurrency(item, key, nestedValue, dataName);
	return nestedValue;
}

export function buildReportExportRows(columnInfo, dataName, rows) {
	const visibleColumns = columnInfo.filter((col) => isVisibleColumn(col[Object.keys(col)[0]]));
	return rows.map((item) => {
		const exportRow = {};
		visibleColumns.forEach((col) => {
			const key = Object.keys(col)[0];
			const colDef = col[key];
			exportRow[colDef.label] = formatExportValue(item, key, colDef, dataName);
		});
		return exportRow;
	});
}
